module.exports = __webpack_public_path__ + "img/2021_1_26_skull_drink.93258e0a.jpg";